import { render, staticRenderFns } from "./Produkte.vue?vue&type=template&id=3d0c20d0&scoped=true"
import script from "./Produkte.vue?vue&type=script&lang=ts"
export * from "./Produkte.vue?vue&type=script&lang=ts"
import style0 from "./Produkte.vue?vue&type=style&index=0&id=3d0c20d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c20d0",
  null
  
)

export default component.exports